export const PublishedEventTypes = {
  Event: 'Event',
  Course: 'Course'
}


// WEBPACK FOOTER //
// ./src/constants/publishedEvent.js